import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React, { useRef } from 'react';

import { ButtonWithUberDialog } from '~common/react/components/ButtonWithUberDialog';
import { imgPath } from '~common/utilities/ImgUrl';
import { usePrevious } from '~src/app/hooks';
import { Messages } from '~src/codegen/Localize';

import { DataQualityTriggerConfigurationUI,DataQualityTriggerConfigurationUIAction } from './DataQualityTriggerDialog';

export type DataQualityTriggerUberDialogProps = {
  readonly dispatch: React.Dispatch<DataQualityTriggerConfigurationUIAction>;
  readonly enableTrigger: boolean;
  readonly isSevere: boolean;
  readonly message: string;
}

export function DataQualityTriggerUberDialog(props: DataQualityTriggerUberDialogProps): JSX.Element {
  const buttonRef = useRef<HTMLButtonElement>();
  const previousEnableTrigger: boolean = usePrevious(props.enableTrigger);
  React.useLayoutEffect(
    // when the dqw checkbox is checked, open the dialog
    () => {
      if (previousEnableTrigger === false && props.enableTrigger === true) {
        buttonRef.current?.click();
       }
    },[previousEnableTrigger, props.enableTrigger]
  );
  const buttonProps = {
    testId: 'LinkedTaskUberDQW',
    buttonType: ButtonType.Icon,
    title: Messages.dataQualityTriggerDialog_Title_Flow(),
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
    }
  };
    return(
      <ButtonWithUberDialog
        dialogWidth={500}
        renderButton={showDialog => (
            <ButtonWidget {...buttonProps} onClick={showDialog} buttonRef={buttonRef}>
              <img src={imgPath('menu_edit.svg')} alt={Messages.dataQualityDialog_Title()} />
            </ButtonWidget>
        )}
        uberDialogContent={
          <DataQualityTriggerConfigurationUI
            contentType={'flow'}
            enableTrigger={props.enableTrigger}
            isSevere={props.isSevere}
            message={props.message}
            dispatch={props.dispatch}
            hideEnableTrigger={true}
          />
        }
      />
    );
  }




